import { useState } from 'react'
import { Flipper, Flipped } from 'react-flip-toolkit'
import styled, { css, keyframes } from 'styled-components'

import { colors } from '@globalStyles'
import doNothing from '@helpers/noop'
import EvetroLogoCenter from '@svg/evetro-logo-center.svg?react'
import EvetroLogoWithoutCenter from '@svg/evetro-logo-without-center.svg?react'

export default function EvetroSpinner({
	onAnimationFinished = doNothing,
	shouldAnimationFinish = false
}: {
	onAnimationFinished?: () => void
	shouldAnimationFinish?: boolean
}) {
	const [nextAnimation, setNextAnimation] = useState('spin')
	const onAnimationIteration = () => {
		if (shouldAnimationFinish) {
			setNextAnimation('enlarge')
		}
	}

	return (
		<FlexFlipper flipKey={nextAnimation}>
			<Flipped flipId="animated-logo">
				<AnimatedLogo
					$spin={nextAnimation === 'spin'}
					onAnimationIteration={onAnimationIteration}
				>
					<EvetroLogoWithoutCenter />
					<EvetroLogoCenter />
				</AnimatedLogo>
			</Flipped>
			<Flipped flipId="animated-text">
				<LoadingText
					$enlarge={nextAnimation === 'enlarge'}
					onAnimationEnd={onAnimationFinished}
				>
					Evetro
				</LoadingText>
			</Flipped>
		</FlexFlipper>
	)
}

const rotate = keyframes`
	to {
		transform: rotate(360deg);
	}
`

const FlexFlipper = styled(Flipper)`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: ${colors.white};
	position: absolute;
	z-index: 9999;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`

const AnimatedLogo = styled.div<{ $spin: boolean }>`
	position: relative;
	margin: 0 auto;
	width: 140px;
	height: 140px;
	display: flex;
	will-change: transform;
	> svg:first-child {
		width: 100%;
		height: 100%;
	}
	> svg:last-child {
		position: absolute;
		width: 100%;
		height: 100%;
		transform-origin: center;
		will-change: transform;
		${({ $spin }) =>
			$spin &&
			css`
				animation: ${rotate} 1400ms infinite linear reverse;
			`}
	}
`

const spaceLetters = keyframes`
	0% {
		letter-spacing: 1px;
		opacity: 0;
	}
	40% {
		opacity: 1;
	}
	100% {
		letter-spacing: 5px;
		opacity: 1;
	}
`

const LoadingText = styled.div<{ $enlarge: boolean }>`
	width: 100%;
	text-align: center;
	font-size: 26px;
	font-weight: 700;
	line-height: 40px;
	color: ${colors.evetro_green};
	text-transform: uppercase;
	opacity: 0;
	${({ $enlarge }) =>
		$enlarge &&
		css`
			animation: ${spaceLetters} 1000ms
				cubic-bezier(0.215, 0.61, 0.355, 1) forwards;
		`}
`
